import * as React from "react";
import { Button } from "components/bootstrap";
const InlineForm = (submitTitle = "Create") => React.forwardRef(({ children, disabled = void 0, onCancel, onSubmitForm }, ref) => {
  const onSubmit = (event) => {
    event.stopPropagation();
    const { target: formDOMNode } = event;
    if (typeof formDOMNode.checkValidity === "function" && !formDOMNode.checkValidity()) {
      event.preventDefault();
      return;
    }
    if (typeof onSubmitForm === "function") {
      event.preventDefault();
      onSubmitForm(event);
    }
  };
  return /* @__PURE__ */ React.createElement("form", { onSubmit, ref }, children, /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled }, submitTitle), " ", /* @__PURE__ */ React.createElement(Button, { type: "button", disabled, onClick: onCancel }, "Cancel"));
});
export default InlineForm;
